
export function createRoutesValidator() {
    class RoutesValidator {
        constructor () {
            this.errors = [];
            this.hasErrors = false;
        }

        validate(routes) {
            this.errors = [];
            this.hasErrors = false;
            routes.map((route, index) => {
                this.errors.push([]);

                if (!route.from.id) this.errors[index].push('from');
                if (!route.to.id) this.errors[index].push('to');
                if (!route.date) this.errors[index].push('date');
                if (!route.time) this.errors[index].push('time');
                if (!route.seats) this.errors[index].push('seats');

                if (this.errors[index].length > 0) {
                    this.hasErrors = true;
                }
            })
        }        
    }
    return new RoutesValidator();
}